<template>
  <div class="wrap" :style="total>0?'padding-top:40px':''">
   <div v-if="total>0" class="top">共{{total}}条</div>
   <template v-if="list.length>0">
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list v-model="loading" offset="20" :finished="finished" finished-text="" @load="onLoad">
        <div>
            <ssb-card  :list="list" ></ssb-card>
        </div>
      </van-list>
    </van-pull-refresh>
   </template>
     <van-empty v-if="!loading && list.length == 0" style="width: 100%; height: 300px" description="暂无数据" />

  </div>
</template>

<script>
import ssbCard from '@/views/common//ssb-card'
import { getAction, postAction } from '@/api/manage'
export default {
  components: {
    ssbCard,
  },
  data() {
    return {
      list: [],
      current: 0,

      loading: true,
      finished: false,
      refreshing: false,
      pageNo: 0,
      total:0,
    }
  },
  created() {
     this.getData();
    // this.getToken()
    //   .then((res) => {
    //     let userInfo = this.getSysUserInfo()
    //     this.getData()
    //   })
    //   .catch((err) => {})
  },
  methods: {

    getList() {
       let openId = this.$store.getters.openId
      var params = {
        pageNo: this.pageNo,
        pageSize: '5',
        appwdsblx:'01',
      }
      getAction('/zhshj/wghgridwork/app/wdsb/page', params).then((res) => {
         this.loading = false
        if (res.success) {
          if (this.refreshing) {
            this.list = []
          }
          let list = res.result.records
          this.total = res.result.total;
          this.list = this.list.concat(this.convert(list))
         
          if (res.result.pages <= this.pageNo) {
            this.finished = true
          }
        } else {
          this.$toast(res.message)
        }
        this.refreshing = false
      })
    },

    getData() {
      this.onRefresh()
    },
    matchType(fileName) {
      // 后缀获取
      var suffix = ''
      // 获取类型结果
      var result = ''
      try {
        var flieArr = fileName.split('.')
        suffix = flieArr[flieArr.length - 1]
      } catch (err) {
        suffix = ''
      }
      // fileName无后缀返回 false
      if (!suffix) {
        result = false
        return result
      }
      // 图片格式
      var imglist = ['png', 'jpg', 'jpeg', 'bmp', 'gif']
      // 进行图片匹配
      result = imglist.some(function (item) {
        return item == suffix
      })
      if (result) {
        result = 'image'
        return result
      }
      // 匹配 视频
      var videolist = ['mp4', 'm2v', 'mkv', 'amr']
      result = videolist.some(function (item) {
        return item == suffix
      })
      if (result) {
        result = 'video'
        return result
      }
      // 匹配 音频
      var radiolist = ['mp3', 'wav', 'wmv']
      result = radiolist.some(function (item) {
        return item == suffix
      })
      if (result) {
        result = 'radio'
        return result
      }
      // 其他 文件类型
      result = 'other'
      return result
    },
    convert(list) {
      var newList = list.map((val) => {
        var imgList = []
        var videoList = []
        var audioList = []
        if (val.fj && val.fj.length > 0) {
          let arr = val.fj.split(',')
          for (var i = 0; i < arr.length; i++) {
            var path = arr[i]
            if (this.matchType(path) == 'image') {
              imgList.push(path)
            } else if (this.matchType(path) == 'video') {
              videoList.push(path)
            } else if (this.matchType(path) == 'radio') {
              audioList.push(path)
            }
          }
        }
        val.delFlag = 'N'
        val.imgList = imgList
        val.videoList = videoList
        val.audioList = audioList

        return val
      })
      return newList
    },
    onLoad() {
      this.pageNo++
      this.getList()
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true
      this.pageNo = 0
      this.refreshing = true
      this.onLoad()
    },
  },
}
</script>

<style lang="less" scoped>
.wrap{
  min-height: 100vh;
  box-sizing: border-box;
  background-color: #f5f5f5;
  padding-top: 0;
}

.top{
  height: 40px;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 99;
  background: #1989fa;
  line-height: 40px;
  text-align: center;
  color: #FFF;
}


::v-deep .van-pull-refresh {
   min-height:calc(100vh)
}
</style>
